import React, { useEffect, useState, useRef } from 'react'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import { FaRegTrashAlt } from 'react-icons/fa'

import {
  Btn,
  BtnIcon,
  CustomCheckbox,
  CustomDataTable,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  CustomTabView,
  InputText,
  Loading,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as TreinamentoHttp from '../../../../services/api/https/settings/treinamento.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { azul } from '../../../../assets/js/colors'

const MODULOS_OPTIONS = [
  { id: 'Sistema', name: 'Sistema' },
  { id: 'Home', name: 'Home' },
  { id: '1. Dashboard', name: '1. Dashboard' },
  { id: '2. Cadastros', name: '2. Cadastros' },
  { id: '3. Entregas', name: '3. Entregas' },
  { id: '4. Picking', name: '4. Picking' },
  { id: '5. Ordem de Coleta', name: '5. Ordem de Coleta' },
  { id: '6. Patrimônio', name: '6. Patrimônio' },
  { id: '7. Insumo', name: '7. Insumo' },
  { id: '8. Estoque', name: '8. Estoque' },
  { id: '9. Gestão de Pátio', name: '9. Gestão de Pátio' },
  { id: '10. Checklist', name: '10. Checklist' },
]

export default function TreinamentoModal({ dispatch, show, data, onClose }) {
  const [treinamento, setTreinamento] = useState({ ...data })
  const [activeIndex, setActiveIndex] = useState(0)
  const [tpsOptions, setTpsOptions] = useState([])
  const [companiesOptions, setCompaniesOptions] = useState([])
  const [materiais, setMateriais] = useState([])
  const [isLoadingMateriais, setIsLoadingMateriais] = useState(false)
  const [tagInput, setTagInput] = useState('')
  const [telaInput, setTelaInput] = useState('')
  const fileInputRef = useRef(null)

  useEffect(() => {
    if (!show) return
    setTreinamento({
      ...data,
      interno: data.interno ? true : false,
      tags: data.tags || '',
      tela: data.tela || '',
    })
    setActiveIndex(0)
    loadOptions()
    if (data.id) {
      loadMateriais(data.id)
    }
  }, [show, data])

  async function loadOptions() {
    try {
      const [tps, companies] = await Promise.all([
        TreinamentoHttp.getActiveTps(),
        TreinamentoHttp.getActiveCompanies(),
      ])
      setTpsOptions(tps.map(tp => ({ value: tp.id, label: `${tp.id} - ${tp.name}` })))
      setCompaniesOptions(companies.map(c => ({ value: c.id, label: `${c.id} - ${c.name}` })))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    }
  }

  async function loadMateriais(treinamentoId) {
    setIsLoadingMateriais(true)
    try {
      const response = await TreinamentoHttp.getMateriais(treinamentoId)
      setMateriais(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoadingMateriais(false)
    }
  }

  function onChange(field, value) {
    setTreinamento(prev => ({ ...prev, [field]: value }))
  }

  function getTags() {
    if (!treinamento.tags) return []
    return treinamento.tags.split(',').filter(t => t.trim() !== '')
  }

  function addTag() {
    if (!tagInput.trim()) return
    const currentTags = getTags()
    if (currentTags.includes(tagInput.trim())) {
      setTagInput('')
      return
    }
    const newTags = [...currentTags, tagInput.trim()].join(',')
    onChange('tags', newTags)
    setTagInput('')
  }

  function removeTag(tag) {
    const currentTags = getTags().filter(t => t !== tag)
    onChange('tags', currentTags.join(','))
  }

  function handleTagKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      addTag()
    }
  }

  function getTelas() {
    if (!treinamento.tela) return []
    return treinamento.tela.split(',').filter(t => t.trim() !== '')
  }

  function addTela() {
    if (!telaInput.trim()) return
    const currentTelas = getTelas()
    if (currentTelas.includes(telaInput.trim())) {
      setTelaInput('')
      return
    }
    const newTelas = [...currentTelas, telaInput.trim()].join(',')
    onChange('tela', newTelas)
    setTelaInput('')
  }

  function removeTela(tela) {
    const currentTelas = getTelas().filter(t => t !== tela)
    onChange('tela', currentTelas.join(','))
  }

  function handleTelaKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      addTela()
    }
  }

  function handleTranscriptionUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = event => {
      onChange('transcription', event.target.result)
    }
    reader.readAsText(file)
    e.target.value = ''
  }

  function onAccessVideo() {
    if (!treinamento.link_video || !treinamento.link_video.trim()) return
    window.open(treinamento.link_video.trim(), '_blank')
  }

  async function onSave() {
    try {
      if (!treinamento.title || !treinamento.title.trim()) {
        return dispatch(showMessageBox(null, 'Título é obrigatório'))
      }
      if (!treinamento.description || !treinamento.description.trim()) {
        return dispatch(showMessageBox(null, 'Descrição é obrigatória'))
      }
      if (!treinamento.link_video || !treinamento.link_video.trim()) {
        return dispatch(showMessageBox(null, 'Link do Vídeo é obrigatório'))
      }
      if (!treinamento.modulo || !treinamento.modulo.trim()) {
        return dispatch(showMessageBox(null, 'Módulo é obrigatório'))
      }
      if (!treinamento.tela || !treinamento.tela.trim()) {
        return dispatch(showMessageBox(null, 'Tela é obrigatória (pelo menos 1)'))
      }

      dispatch(showLoadingBox('Salvando...'))

      const usuario = getUsuarioInfo()
      const payload = {
        ...treinamento,
        interno: treinamento.interno ? 1 : 0,
        created_by: usuario.id,
      }

      const saved = await TreinamentoHttp.saveTreinamento(payload)
      setTreinamento({
        ...saved,
        interno: saved.interno ? true : false,
      })

      if (!treinamento.id) {
        await loadMateriais(saved.id)
      }

      dispatch(hideLoadingBox())
      dispatch(showMessageBox('Treinamento salvo com sucesso!'))
    } catch (error) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, error))
    }
  }

  async function onUploadMaterial() {
    const input = document.createElement('input')
    input.type = 'file'
    input.onchange = async e => {
      const file = e.target.files[0]
      if (!file) return

      try {
        dispatch(showLoadingBox('Fazendo upload...'))
        const usuario = getUsuarioInfo()

        // Upload to S3
        const uploadResult = await TreinamentoHttp.uploadMaterialToS3(treinamento.id, file)

        // Save record in database
        const material = await TreinamentoHttp.saveMaterial(treinamento.id, {
          name: file.name,
          path: uploadResult.url,
          uploaded_by: usuario.id,
        })

        setMateriais(prev => [...prev, material])
        dispatch(hideLoadingBox())
        dispatch(showMessageBox('Material de apoio enviado com sucesso!'))
      } catch (error) {
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(null, error))
      }
    }
    input.click()
  }

  async function onDeleteMaterial(material) {
    try {
      dispatch(showLoadingBox('Excluindo...'))

      // Extract filename from path URL
      const pathParts = material.path.split('/')
      const filename = pathParts[pathParts.length - 1]

      // Delete from S3 first
      await TreinamentoHttp.deleteMaterialFromS3(filename)

      // Then delete from database
      await TreinamentoHttp.deleteMaterial(material.id)

      setMateriais(prev => prev.filter(m => m.id !== material.id))
      dispatch(hideLoadingBox())
      dispatch(showMessageBox('Material excluído com sucesso!'))
    } catch (error) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, error))
    }
  }

  const linkBodyTemplate = rowData => {
    return (
      <a href={rowData.path} target="_blank" rel="noopener noreferrer">
        Acessar
      </a>
    )
  }

  const deleteBodyTemplate = rowData => {
    return (
      <BtnIcon onClick={() => onDeleteMaterial(rowData)}>
        <FaRegTrashAlt color="#dc3545" />
      </BtnIcon>
    )
  }

  const isMateriaisEnabled = !!treinamento.id

  return (
    <CustomModal
      isVisible={show}
      onClose={onClose}
      header="Treinamento"
      width="90vw"
      style={{ maxWidth: '700px' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={setActiveIndex}>
        <TabPanel header="Vídeo">
          <div style={{ padding: 10 }}>
            <InputText
              label="Título *"
              value={treinamento.title}
              onChange={value => onChange('title', value)}
            />

            <CustomInputTextArea
              label="Descrição *"
              value={treinamento.description}
              onChange={value => onChange('description', value)}
              rows={3}
            />

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 10 }}>
              <div style={{ flex: '1 1 400px' }}>
                <CustomInputTextArea
                  label="Transcrição"
                  value={treinamento.transcription || ''}
                  onChange={value => onChange('transcription', value)}
                  rows={4}
                />
              </div>
              <div>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".txt"
                  style={{ display: 'none' }}
                  onChange={handleTranscriptionUpload}
                />
                <Btn onClick={() => fileInputRef.current.click()}>Upload .txt</Btn>
              </div>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 10 }}>
              <div style={{ flex: '1 1 400px' }}>
                <InputText
                  label="Link do Vídeo *"
                  value={treinamento.link_video}
                  onChange={value => onChange('link_video', value)}
                />
              </div>
              <Btn onClick={onAccessVideo}>Acessar</Btn>
            </div>

            {/* Tags */}
            <div style={{ marginTop: 20 }}>
              <label style={{ display: 'block', color: azul, fontSize: '0.8rem' }}>Tags</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 5 }}>
                {getTags().map((tag, idx) => (
                  <span
                    key={idx}
                    style={{
                      background: '#007bff',
                      color: '#fff',
                      padding: '3px 8px',
                      borderRadius: 12,
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {tag}
                    <span
                      style={{ cursor: 'pointer', fontWeight: 'bold' }}
                      onClick={() => removeTag(tag)}
                    >
                      ×
                    </span>
                  </span>
                ))}
              </div>
              <input
                type="text"
                className="p-inputtext p-component"
                style={{ width: '100%' }}
                placeholder="Digite uma tag e pressione Enter"
                value={tagInput}
                onChange={e => setTagInput(e.target.value)}
                onKeyDown={handleTagKeyDown}
              />
            </div>

            {/* Interno */}
            <div style={{ marginTop: 20 }}>
              <CustomCheckbox
                checked={treinamento.interno}
                onChange={value => onChange('interno', value)}
              >
                Interno
              </CustomCheckbox>
            </div>

            {/* TP */}
            <CustomDropdown
              label="TP"
              optionLabel="label"
              options={tpsOptions}
              value={tpsOptions.find(tp => tp.value === treinamento.tp_id) || null}
              onChange={val => onChange('tp_id', val ? val.value : null)}
              filter
              marginTop={20}
              placeholder="Selecione um TP (opcional)"
            />

            {/* Empresa */}
            <CustomDropdown
              label="Empresa"
              optionLabel="label"
              options={companiesOptions}
              value={companiesOptions.find(c => c.value === treinamento.company_id) || null}
              onChange={val => onChange('company_id', val ? val.value : null)}
              filter
              marginTop={20}
              placeholder="Selecione uma Empresa (opcional)"
            />

            {/* Módulo */}
            <CustomDropdown
              label="Módulo *"
              optionLabel="name"
              options={MODULOS_OPTIONS}
              value={MODULOS_OPTIONS.find(m => m.id === treinamento.modulo) || null}
              onChange={val => onChange('modulo', val ? val.id : '')}
              marginTop={20}
              placeholder="Selecione um Módulo"
            />

            {/* Tela */}
            <div style={{ marginTop: 20 }}>
              <label style={{ display: 'block', color: azul, fontSize: '0.8rem' }}>Tela *</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 5 }}>
                {getTelas().map((tela, idx) => (
                  <span
                    key={idx}
                    style={{
                      background: '#28a745',
                      color: '#fff',
                      padding: '3px 8px',
                      borderRadius: 12,
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {tela}
                    <span
                      style={{ cursor: 'pointer', fontWeight: 'bold' }}
                      onClick={() => removeTela(tela)}
                    >
                      ×
                    </span>
                  </span>
                ))}
              </div>
              <input
                type="text"
                className="p-inputtext p-component"
                style={{ width: '100%' }}
                placeholder="Digite uma tela e pressione Enter"
                value={telaInput}
                onChange={e => setTelaInput(e.target.value)}
                onKeyDown={handleTelaKeyDown}
              />
            </div>

            <div style={{ marginTop: 15 }}>
              <Btn onClick={onSave}>Salvar</Btn>
            </div>
          </div>
        </TabPanel>

        <TabPanel header="Materiais de Apoio" disabled={!isMateriaisEnabled}>
          <div style={{ padding: 10 }}>
            <div style={{ marginBottom: 10 }}>
              <Btn onClick={onUploadMaterial}>Novo Upload</Btn>
            </div>
            {isLoadingMateriais ? (
              <div className="text-center">
                <Loading size="md" />
              </div>
            ) : (
              <CustomDataTable value={materiais} paginator rows={10}>
                <Column field="name" header="Nome do Arquivo" />
                <Column
                  header="Link"
                  body={linkBodyTemplate}
                  style={{ width: 100, textAlign: 'center' }}
                />
                <Column
                  header=""
                  body={deleteBodyTemplate}
                  style={{ width: 60, textAlign: 'center' }}
                />
              </CustomDataTable>
            )}
          </div>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}
